import { createElementVNode as _createElementVNode, openBlock as _openBlock, withModifiers as _withModifiers, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mt-4 p-4 text-[14px] bg-theme-modalbg rounded-lg" }
const _hoisted_2 = { class: "relative" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "m-2 mt-4 tracking-wider grid-cols-4 bg-theme-modal_inner_bg rounded py-2 px-2 pb-4" }
const _hoisted_5 = { class: "full justify-content-center" }
const _hoisted_6 = { class: "text-center text-white text-md mt-2" }
const _hoisted_7 = { class: "full flex" }
const _hoisted_8 = { class: "mt-3 mb-1 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_custom_modal = _resolveComponent("custom-modal")!

  return (_ctx.vg_active)
    ? (_openBlock(), _createBlock(_component_custom_modal, {
        key: 0,
        size: 'max-w-3xl'
      }, {
        maincontent: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h2", {
                class: "text-2xl text-white text-center pr-[40px]",
                innerHTML: _ctx.vg_msg
              }, null, 8, _hoisted_3),
              _createElementVNode("span", {
                class: "absolute right-1 top-1 pointer cursor-pointer hover:opacity-60",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.reject()), ["prevent"]))
              }, [...(_cache[3] || (_cache[3] = [
                _createElementVNode("svg", {
                  width: "20",
                  height: "20",
                  viewBox: "0 0 20 20",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("path", {
                    d: "M19.3333 2.54602L17.4533 0.666016L10 8.11935L2.54667 0.666016L0.666672 2.54602L8.12001 9.99935L0.666672 17.4527L2.54667 19.3327L10 11.8793L17.4533 19.3327L19.3333 17.4527L11.88 9.99935L19.3333 2.54602Z",
                    fill: "white"
                  })
                ], -1)
              ]))])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.vg_extraMsg), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.accept()), ["prevent"])),
                  class: "uppercase text-white bg-theme-green hover:bg-theme-darkgreen w-3/5 mt-6 text-lg border-0 rounded-md p-2 block mx-auto"
                }, "CONFIRM")
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.reject()), ["prevent"])),
                class: "text-white hover:text-theme-green text-center"
              }, "CLOSE")
            ])
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}